export default __webpack_public_path__ + "static/docs@2x-0452bb6984d6086e22d993827db38775.png";